"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledMultipleChoiceContentContent = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const getGridTemplateColumns = (count) => {
    let result = '';
    let c = count;
    while (c--) {
        result += '1fr ';
    }
    return result;
};
exports.StyledMultipleChoiceContentContent = styled_components_1.default.div `
    display: grid;
    grid-template-columns: ${({ columnCount }) => getGridTemplateColumns(columnCount)};
    overflow-x: auto;
`;
//# sourceMappingURL=MultipleChoiceContent.styles.js.map